import { Stack, IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTenantTranslation } from "hooks/formatters";

type ExampleNavigationControlsProps = Readonly<{
  currentIndex: number;
  totalCount: number;
  onPrevious: () => void;
  onNext: () => void;
}>;

export const ExampleNavigationControls = ({
  currentIndex,
  totalCount,
  onPrevious,
  onNext,
}: ExampleNavigationControlsProps) => {
  const { t } = useTenantTranslation();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <IconButton onClick={onPrevious} disabled={currentIndex === 0}>
        <ChevronLeftIcon />
      </IconButton>
      <Typography variant="body2" color="text.secondary">
        {t("exampleCount", {
          current: currentIndex + 1,
          total: totalCount,
        })}
      </Typography>
      <IconButton onClick={onNext} disabled={currentIndex === totalCount - 1}>
        <ChevronRightIcon />
      </IconButton>
    </Stack>
  );
};
